import { Section } from "@/components/layout/Section";
import { Container } from "@/components/layout/Container";

export function About() {
  return (
    <Section id="about" className="bg-sage-light/30">
      <Container className="max-w-3xl text-center">
        <h2 className="text-3xl sm:text-4xl font-light tracking-tight text-foreground mb-8">
          Crafting Digital Experiences
        </h2>
        <p className="text-lg text-muted-foreground leading-relaxed mb-6">
          At Bakerysoft, we believe that great software should feel effortless.
          We craft applications with meticulous attention to detail, focusing on
          intuitive design and seamless functionality.
        </p>
        <p className="text-lg text-muted-foreground leading-relaxed">
          Every app we build is made with care, combining thoughtful user
          experience with robust engineering to create products that people
          genuinely enjoy using.
        </p>
      </Container>
    </Section>
  );
}
